// extracted by mini-css-extract-plugin
module.exports = {"depositColor":"#55c3b9","stampDutyColor":"#2762c1","legalFeesColor":"#fa5959","mortgageColor":"#ffc700"};